var React = require('react');

function MusicSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192 387.92a139 139 0 0 0-32-3.92c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V327.88l-64-49.46zM534.38 1.51L214.41 96a31.87 31.87 0 0 0-21 21.73l107.82 83.32L512 139.3v184.62a139 139 0 0 0-32-3.92 136.93 136.93 0 0 0-22.15 2.11l110.91 85.71c4.51-7.37 7.24-15.35 7.24-23.82V32a32 32 0 0 0-41.62-30.49z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M633.82 458.1L45.47 3.39A16 16 0 0 0 23 6.2L3.37 31.47a16 16 0 0 0 2.81 22.45l588.35 454.71a16 16 0 0 0 22.47-2.81l19.63-25.27a16 16 0 0 0-2.81-22.45z","className":"fa-primary","key":2})]);
}

MusicSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = MusicSlash;

MusicSlash.default = MusicSlash;
